import React from "react"
import BaseSvgIcon from "./Base"

const PeopleSolid = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 12 12" {...props}>
      <path d="M1.79961 3.6C1.79961 2.43938 2.73898 1.5 3.89961 1.5C5.06023 1.5 5.99961 2.43938 5.99961 3.6C5.99961 4.76063 5.06023 5.7 3.89961 5.7C2.73898 5.7 1.79961 4.76063 1.79961 3.6ZM0.599609 9.9C0.599609 8.0775 2.07711 6.6 3.89961 6.6C5.72211 6.6 7.19961 8.0775 7.19961 9.9V10.0125C7.19961 10.4475 6.84711 10.8 6.41211 10.8H1.38711C0.952109 10.8 0.599609 10.4475 0.599609 10.0125V9.9ZM8.69961 2.4C9.69336 2.4 10.4996 3.20625 10.4996 4.2C10.4996 5.19375 9.69336 6 8.69961 6C7.70586 6 6.89961 5.19375 6.89961 4.2C6.89961 3.20625 7.70586 2.4 8.69961 2.4ZM8.69961 6.9C10.1902 6.9 11.3996 8.10938 11.3996 9.6V10.02C11.3996 10.4513 11.0509 10.8 10.6196 10.8H7.90461C8.02836 10.5656 8.09961 10.2975 8.09961 10.0125V9.9C8.09961 8.93438 7.77336 8.04563 7.22773 7.33688C7.65148 7.06125 8.15773 6.9 8.69961 6.9Z" />
    </BaseSvgIcon>
  )
}

export default PeopleSolid
